import { SiteFooter, SiteHeader } from "./SiteChrome";
import { CmsContent } from "./CmsContent";

export function PrivacyPolicyPage() {
  return (
    <>
      <SiteHeader />
      <main className="site-shell" style={{ paddingTop: 120, paddingBottom: 100, minHeight: "70vh" }}>
        <p className="eyebrow"><span>—</span>Legal</p>
        <h1 className="page-title">Privacy Policy</h1>
        <div style={{ maxWidth: 720, marginTop: 24 }}>
          <CmsContent
            contentKey="privacy-policy"
            fallbackTitle=""
            fallbackBody="This page is being finalized. If you have questions about how we handle your information, please contact us at info@formulasoccer.com."
          />
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
